import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Edititemmodal from "./edititemmodal";
import money_rounding from "../../utils/money_rounding";
import { useNavigate } from 'react-router-dom';

const Itemlist = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const navigate = useNavigate();

  const [item_id, setitem_id] = useState();
  const [item_name, setitem_name] = useState();
  const [item_price, setitem_price] = useState();
  const [item_barcode, setitem_barcode] = useState();
  const [item_unit_one, setitem_unit_one] = useState();
  const [item_unit_many, setitem_unit_many] = useState();
  const [item_unit_one_of_many, setitem_unit_one_of_many] = useState();
  const [item_min_notification, setitem_min_notification] = useState();
  const [category_id, setcategory_id] = useState();
  const [show, setshow] = useState(false);

  return (
    <div>
      <Edititemmodal
        item_id={item_id}
        item_name={item_name}
        setitem_name={setitem_name}
        item_price={item_price}
        setitem_price={setitem_price}
        item_barcode={item_barcode}
        setitem_barcode={setitem_barcode}
        item_unit_one={item_unit_one}
        setitem_unit_one={setitem_unit_one}
        item_unit_many={item_unit_many}
        setitem_unit_many={setitem_unit_many}
        item_unit_one_of_many={item_unit_one_of_many}
        setitem_unit_one_of_many={setitem_unit_one_of_many}
        item_min_notification={item_min_notification}
        setitem_min_notification={setitem_min_notification}
        category_id={category_id}
        setcategory_id={setcategory_id}
        show={show}
        setshow={setshow}
      />
      {/* Table */}
      <table className="w-full">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-100">
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              ناوی کاڵا
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              کۆد
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              نرخ
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              یەکەی کۆ
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              یەکەی تاک
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              بڕی یەکەی تاک لە یەک یەکەی کۆدا
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              بڕی ماوە
            </th>
            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              گۆڕانکاری
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-50">
          {initState.item.map((lis) => (
            <tr
              key={lis.item_id}
              className="hover:bg-slate-50 transition-colors duration-100"
            >
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right ">
                <p className={"text-indigo-600 whitespace-nowrap underline cursor-pointer"}
                  onClick={() =>{
                    initDispatch({type:'setitem_ledger', payload:{ledger_item_id:lis.item_id, ledger_item_code:lis.item_barcode, ledger_item_name:lis.item_name, ledger_item_unit_one:lis.item_unit_one, ledger_item_unit_many:lis.item_unit_many, ledger_item_unit_one_of_many:lis.item_unit_one_of_many}});
                    navigate('/item/ledger');
                  }}
                >
                  {lis.item_name}
                </p>
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.item_barcode}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {numberbeautify(money_rounding(lis.item_price))} $
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.item_unit_many}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.item_unit_one}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {numberbeautify(money_rounding(lis.item_unit_one_of_many))}
              </td>
              <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.item_unit_one} {Math.floor(lis.item_qty/lis.item_unit_one_of_many)}/{money_rounding(Number(lis.item_qty) % lis.item_unit_one_of_many)} {lis.item_unit_many}
              </td>
              <td
                className="px-6 py-4 text-right"
              >
                <button
                  className={
                    "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                  }
                  onClick={() => {
                    setitem_id(lis.item_id);
                    setitem_name(lis.item_name);
                    setitem_price(lis.item_price);
                    setitem_barcode(lis.item_barcode);
                    setitem_unit_one(lis.item_unit_one);
                    setitem_unit_many(lis.item_unit_many);
                    setitem_unit_one_of_many(lis.item_unit_one_of_many);
                    setitem_min_notification(lis.item_min_notification);
                    setcategory_id(lis.category_id);
                    setshow(true);
                  }}
                >
                  گۆڕانکاری
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Itemlist;
